import { CheckBadgeIcon, ArchiveBoxIcon } from "@heroicons/react/24/solid";
import React from "react";
import { hardwareSkills, softwareSkills }  from "../components/skills/skillData";

export default function Skills() {
  return (
    <section id="skills" className = "bg-gray-900 text-gray-400 body-font">
      <div className="container px-5 py-10 mx-auto">
        <div className="text-center mb-20">
          <ArchiveBoxIcon className="w-1/4 inline-block mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-4">
            Skills
          </h1>
        </div>
        <div>
            <h1 className="text-2xl title-font font-medium text-white mb-2 mx-16">
                Hardware
            </h1>
        </div>
        <div className="flex flex-wrap lg:w-4/5 sm:mx-auto -mx-2 mb-8">
          {hardwareSkills.map((skill) => (
            <div key={skill} className="p-2 sm:w-1/2 w-full">
              <div className="bg-gray-800 rounded flex p-4 h-full items-center">
                <CheckBadgeIcon className="text-green-400 w-6 h-6 flex-shrink-0 mr-4" />
                <span className="title-font font-medium text-white">
                  {skill}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div>
            <h1 className="text-2xl title-font font-medium text-white mb-2 mx-16">
                Software
            </h1>
        </div>
        <div className="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
          {softwareSkills.map((skill) => (
            <div key={skill} className="p-2 sm:w-1/2 w-full">
              <div className="bg-gray-800 rounded flex p-4 h-full items-center">
                <CheckBadgeIcon className="text-green-400 w-6 h-6 flex-shrink-0 mr-4" />
                <span className="title-font font-medium text-white">
                  {skill}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}